import { useQuery } from '@provision/graphql-client';
import { isNullish } from 'remeda';
import { GET_LEGAL_DOCUMENT_LINKS_QUERY } from 'src/graphql/entities/legal-document/legal-document.operations';

interface LegalDocumentLinksData {
  getLegalDocumentLinks: { termsOfServiceUrl: string | null; privacyPolicyUrl: string | null };
}

export const useLegalDocumentLinks = ({
  partnerId,
  brandId,
}: {
  partnerId: number | null | undefined;
  brandId: string | null | undefined;
}) => {
  const shouldSkip = isNullish(partnerId) || !brandId;

  const { data, loading } = useQuery<LegalDocumentLinksData>(GET_LEGAL_DOCUMENT_LINKS_QUERY, {
    skip: shouldSkip,
    variables: { input: { partnerId, brandId } },
  });

  return {
    termsOfServiceUrl: data?.getLegalDocumentLinks.termsOfServiceUrl ?? '',
    privacyPolicyUrl: data?.getLegalDocumentLinks.privacyPolicyUrl ?? '',
    loading: !shouldSkip && loading,
  };
};
